import { Component, OnInit, ViewChild } from '@angular/core';
import { Observable } from "rxjs";
import { ToastrService } from 'ngx-toastr';

import { MessageTemplate } from '../../../api/models/message-template';
import { Customer } from '../../../api/models/customer';
import { EmailMessage } from '../../../api/models/email-message';
import { CustomerService, MessageTemplateService} from '../../../api/services';
import { MessageTemplateTableService } from 'src/service/message-template.service';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { CustomerDistribution } from 'src/api/models/customer-distribution';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { FormatMessage } from 'src/api/models';



@Component({
  selector: 'app-message-template',
  templateUrl: './message-template.component.html',
  styleUrls: ['./message-template.component.css']
})
export class MessageTemplateComponent implements OnInit {

  public customer : CustomerDistribution = {} as CustomerDistribution;
  //public messageTemplate : MessageTemplate = {} as MessageTemplate;

  public remoteData: Observable<any[]>;
  public remoteItemData: Observable<any[]>;

  textData: string = "{{message}}";
  jsonData: string = "{{$.path.to.my.data}}";
  example: string = "<div class=\"card\">\n  <div class=\"card-body\">\n      <div class=\"h3\">{{data.db_decoded.deviceType}}</div>\n        <ul>\n{{#each data.calculations}}\n         <li>{{this.Duration}}</li>\n{{/each}}\n      </ul>\n      <div>Wind Speed:{{data.db_decoded.windSpeed}}</div>\n      <div>Meta Data:{{metaData.siteType}}</div>\n      <div>Latitude:{{latitude}}</div>\n      <div>Longitude:{{longitude}}</div>\n  <div>Time Stamp:{{data.timeStamp}}</div>\n </div>\n  <div class=\"card-arrow\">\n      <div class=\"card-arrow-top-left\"></div>\n      <div class=\"card-arrow-top-right\"></div>\n      <div class=\"card-arrow-bottom-left\"></div>\n      <div class=\"card-arrow-bottom-right\"></div>\n  </div>\n</div>";
  emailExample: string = "<div=\"card\">\r\n\t<div class=\"card-body\">\r\n\t\t<!-- if the message is a string -->\r\n\t\t<div class=\"h3\">{{message}}</div>\r\n\t\t<1-- if the message is an object -->\r\n\t\t<div class=\"h3\">{{message.your.object.value}}</div>\r\n\t\t <!--conditional variable example-->\r\n\t\t{{#ifCond message.your.object.value '>' 200}} <div>HIGH VALUE</div> {{/ifCond}} \r\n\t\t <!--conditional class example-->\r\n\t\t<div {{#ifCond message.your.object.value '<=>' 200}} style=\"color:green\"> {{/ifCond}} HIGH VALUE </div> \r\n\t\t<ul>\r\n\t\t\t{{#each message.calculations}} \r\n\t\t\t<!-- this.x lets you access members inside the looped object -->        \r\n\t\t\t<li>{{this.measuredValue}}</li>\r\n\t\t\t{{/each}}\r\n\t\t</ul>\r\n\t\t<div>Subject:{{subject}}</div>\r\n\t\t<div>SMS:{{sms}}</div>\r\n\t\t<div>Value:{{value.Point.Value}}</div>\r\n\t\t<div>Time Stamp:{{value.Point.TimeStamp}}</div>\r\n\t\t<!-- access the meta data attached to the value -->\r\n\t\t<div>Meta Data:{{value.MetaData.siteType}}</div>\r\n\t\t<!-- default meta data for an alarm includes -->\r\n\t\t<div>Meta Data:{{value.MetaData.alarmValue}}</div>\r\n\t\t<div>Meta Data:{{value.MetaData.alarmName}}</div>\r\n\t\t<div>Meta Data:{{value.MetaData.alarmCheck}}</div>\r\n\t\t<div>Meta Data:{{value.MetaData.alarmMatch}}</div>\r\n\t</div>\r\n</div>";
  showExample: boolean = false;

  subjectToSend: string;
  messageToSend: string;
  useTemplate: boolean;
  liveRender: string;
  public messageTemplate: MessageTemplate;
  public newMessageTemplate: MessageTemplate;

  constructor(
    public service: MessageTemplateTableService,
    private mtService: MessageTemplateService,
    public app: ApplicationConfigService,
    private customerService: CustomerService,
    public azureAuthService: AzureAuthService,
    private toasterService: ToastrService,
  ) { 
    this.remoteData = this.service.remoteData;
    console.log(this.messageTemplate);
    app.customerChanged$.subscribe(cid => {
      this.ngOnInit();
    });
  }

  ngOnInit(): void {    
    if (this.azureAuthService.isGlobalViewer()){
      if (this.app.customers == null){
        this.customerService.CustomerGetAllCustomers().subscribe(c => {           
          this.app.customers = c;//.filter(c=>c.active);          
        });
      }
    } 
    if (this.app.customerId == null) {
      this.app.customerId = this.azureAuthService.userProfile.customerId;
    }
    if (this.app.customerId){
      this.service.get(this.app.customerId);
    }
  } 

  changeCustomer(){
    if (this.azureAuthService.isGlobalViewer()){
      this.service.get(this.app.customerId);
    }
  }
  
  public removeRow(list) {
    // todo: move this into service 
    if (confirm("Are you sure you want to delete this Distribution List?")){
      this.service.remove(list.messageTemplateId);
    }
  }


  saveMessageTemplate(mt){
    mt.Customer = { customerId:this.app.customerId } as Customer;
    this.service.update(mt);
  }

  public addList(){
    this.newMessageTemplate = {} as MessageTemplate;
  }

  public addListSave(){
    this.service.add(this.app.customerId, this.newMessageTemplate);
  }

  public updateListSave(){
    this.service.update(this.messageTemplate)
  }

  public isDeleted(rowContext: any) {
    return rowContext && rowContext.deleted;
  }


  messageChangedCount: number = 0;
  public messageChanged($event){
    this.messageChangedCount++;
    var innerCount = this.messageChangedCount;
    setTimeout(() => {
        if (this.messageChangedCount == innerCount){
          this.mtService.MessageTemplateFormatMessage({
              emailMessage: {
                message:this.messageTemplate.sampleMessage,
                subject:this.subjectToSend,
                applyTemplate:true,
                value: JSON.stringify({ point: { value: "value", timeStamp: "timeStamp" }, metaData:{source:"Live Render"}}),
                messageTemplateId: this.messageTemplate.messageTemplateId
              } as EmailMessage,
              messageTemplate: this.messageTemplate
            } as FormatMessage).subscribe(r => {
              this.liveRender = r.message;
            });
        }
      }, 1000);
  }

}


